export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    return;
  }

  const { emitEvent } = analyticsUtils();

  emitEvent('navigation', { route_change: `${from.path} -> ${to.path}` });
});
